import { AxiosPromise } from 'axios'

import ClientSDK from '../../App/ClientSDK'
import { IApiActivity } from '../interface/IActivity'
import {
  IApiBulkActivityWithCabinsAndDevices,
  IBulkActivityWithCabinsAndDevices,
} from '../interface/IBulkActivityWithCabinsAndDevices'

class ActivityDataStore {
  static async getAllActivities(offset?: number) {
    if (!offset) {
      offset = 0
    }

    const limit = 200

    const response = await this.getActivities(offset, limit)
    const total = response.data.meta.total
    let activities = response.data.data
    if (offset + limit < total) {
      const nextActivities = await this.getAllActivities(offset + limit)
      activities = activities.concat(nextActivities)
    }

    return activities
  }

  static getActivities(offset: number, limit: number, sorting?: any[]) {
    const params = new URLSearchParams()
    if (offset) params.append('page[offset]', offset.toString())
    if (limit) params.append('page[limit]', limit.toString())
    if (sorting) {
      const fields = []
      for (const field in sorting) {
        if (!sorting.hasOwnProperty(field)) continue

        fields.push(sorting[field] === 'DESC' ? '-' + field : field)
      }
      params.append('sort', fields.join(','))
    }

    const url = 'activities?' + params.toString()

    return ClientSDK.instance().get<{data: IApiActivity[], meta: { total: number } }>(url)
  }

  static getActivitiesWithTreatmentCode(): AxiosPromise {
    const url = 'activities/with-treatment-code'

    return ClientSDK.instance().get(url)
  }

  static async getActivitiesForBulkEdit(
    offset: number,
    limit: number,
    sorting?: any[],
  ) {
    const params = new URLSearchParams()
    if (offset) params.append('page[offset]', offset.toString())
    if (limit) params.append('page[limit]', limit.toString())
    if (sorting) {
      const fields = []
      for (const field in sorting) {
        if (!sorting.hasOwnProperty(field)) continue

        fields.push(sorting[field] === 'DESC' ? '-' + field : field)
      }
      params.append('sort', fields.join(','))
    }

    const url = 'activities/bulk-edit?' + params.toString()

    const result = await ClientSDK.instance().get<{
      data: IApiBulkActivityWithCabinsAndDevices[]
      count: number
    }>(url)

    const data: IBulkActivityWithCabinsAndDevices[] = result.data.data.map(
      row => {
        const updatedRow: IBulkActivityWithCabinsAndDevices = {
          id: row.id,
          name: row.name,
          category_id: row.category_id,
        }

        for (const deviceId of row.device_ids) {
          updatedRow['device_' + deviceId] = true
        }

        for (const cabinId of row.cabin_ids) {
          updatedRow['cabin_' + cabinId] = true
        }

        return updatedRow
      },
    )

    return {
      count: result.data.count,
      data,
    }
  }

  // TODO typing any for now, don't want to break old Table
  static updateActivity(activity: any) {
    const url = 'activities/' + activity.id

    const transformedActivity = Object.keys(activity).reduce(
      (acc, curr) => {
        if (curr.startsWith('device_') && acc[curr]) {
          acc.devices.push(curr.substring(7))
          delete acc[curr]
        }

        if (curr.startsWith('cabin_') && acc[curr]) {
          acc.cabins.push(curr.substring(6))
          delete acc[curr]
        }

        return acc
      },
      { ...activity, devices: [], cabins: [] },
    )

    return ClientSDK.instance().post(url, transformedActivity)
  }

  static getActivityCategories(): AxiosPromise {
    const url = 'activity-categories'

    return ClientSDK.instance().get(url)
  }

  static getDepartments(): AxiosPromise {
    const url = 'departments'

    return ClientSDK.instance().get(url)
  }
}

export default ActivityDataStore
